import React, { Component } from 'react';
import './DrugPage.css';
import Page from '../../components/page/Page';
import models from '../../model/models';
import DrugCard from '../../cards/drugCard/DrugCard';
import mainAPI from '../../api/MainAPI';
import UpdateTitle from '../../components/updateTitle/UpdateTitle';
import DrugTypeSummary from "../../cards/drugTypeSummary/DrugTypeSummary";

export default class DrugPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			search: '',
			user_group: {}
		};
	}

	componentDidMount = () => {
		this.subscribeId = models.drug.onChange(this._updateDrugs);
		this.groupSubscribeId = models.user_group.onChange(this._updateUserGroup);
		this.typeSubId = models.drug_type.onChange(this._updateDrugTypes);
	};

	componentWillUnmount = () => {
		models.drug.unsubscribe(this.subscribeId);
		models.user_group.unsubscribe(this.groupSubscribeId);
		models.drug_type.unsubscribe(this.typeSubId);
	};

	_updateUserGroup = () => {
		let user_group = models.user_group.obj();
		this.setState({ user_group });
	};

	_updateDrugs = async () => {
		// let drugs = await mainAPI.drug.get_all_with_last_check();
		let drugs = models.drug.objs();
		this.setState({ drugs });
		await this._updateUsedDrugs();
	};

	_updateUsedDrugs = async () => {
		let usedDrugs = await mainAPI.drug.used();
		this.setState({ usedDrugs });
	};

	_updateDrugTypes = () => {
		let types = models.drug_type.allowed();
		this.setState({ types });
	};

	render() {
		return (
			<Page className="g-drug-page">
				<UpdateTitle newTitle="Drugs" originalTitle="LogRx" />
				<DrugTypeSummary types={this.state.types} user_group={this.state.user_group} includePar drugs={this.state.drugs} />
				<DrugCard drugs={this.state.drugs} />
				<DrugCard allowUsedDrugs displayNewDrugButton={false} drugs={this.state.usedDrugs} title="Used Drugs" />
			</Page>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/drugPage/DrugPage.jsx